const shell = {
  projectSyncError: 'We could not load your enterprise projects. Check your connection and try again.',
  retry: 'Try again',
  projectSwitcher: 'Project switcher',
  switchWorkspace: 'Switch enterprise space',
  home: 'Navigator home',
  project: 'Project',
  currentProject: 'Current project',
  newProject: 'Create project',
  navigation: 'Primary navigation',
  nav: {
    memory: 'Memory',
    diagnosis: 'Diagnosis',
    action: 'Actions',
    presence: 'Presence',
    results: 'Results',
  },
  appearance: 'Appearance',
  themeButtonLabel: 'Appearance · {theme}',
  settings: 'Settings',
  settingsIntro: 'Manage your interface, workspace and project preferences.',
  personal: 'Personal',
  workspace: 'Workspace',
  projectSettings: 'Project',
  interfaceLanguage: 'Interface language',
  interfaceLanguageHint: 'Changes Navigator controls only. Company facts and evidence remain in their original language.',
  followSystem: 'Follow system',
  theme: 'Theme',
  themeSystem: 'System',
  themeLight: 'Light',
  themeDark: 'Dark',
  close: 'Close',
  vaultConnected: 'Project workspace ready',
  workspaceSettingsIntro: 'Manage shared workspace preferences for this company.',
  membersEyebrow: 'Workspace access control',
  membersTitle: 'Members & permissions',
  membersIntro: 'Choose which work emails can enter this workspace and what each member can do.',
  membersScope: 'These permissions apply to every project in this workspace.',
  activeMembers: 'active members',
  memberRoles: {
    tenant_admin: 'Workspace administrator',
    operator: 'Operator',
    member: 'Member',
  },
  memberRoleShort: {
    tenant_admin: 'Manage members, settings and all operations.',
    operator: 'Review leads, assign owners and record follow-up.',
    member: 'Use workspace projects and handle assigned work.',
  },
  memberRoleDetail: {
    tenant_admin: 'Can manage members and settings, enter operations, and assign leads to other members.',
    operator: 'Can enter operations, review leads, and assign leads to active members.',
    member: 'Can use workspace projects and handle assigned work; cannot manage members.',
  },
  memberStatuses: { active: 'Active', revoked: 'Deactivated' },
  memberList: 'Workspace members',
  memberFilter: 'Member filter',
  addMember: 'Add member',
  manageMember: 'Manage',
  currentAccount: 'Current account',
  noMembers: 'There are no members in this state.',
  membersLoading: 'Loading workspace members…',
  membersLoadFailed: 'We could not load workspace members.',
  memberBoundaryTitle: 'V1 boundary:',
  memberBoundaryBody: 'This controls workspace access only. Departments and project-level permissions are not included. Deactivation immediately ends existing sessions.',
  memberPermissionTitle: 'Only workspace administrators can manage members.',
  memberPermissionBody: 'Your current access remains unchanged.',
  addMemberTitle: 'Add workspace member',
  addMemberIntro: 'Add a work email to the current workspace.',
  editMemberTitle: 'Manage member',
  editMemberIntro: 'Role changes take effect immediately after saving.',
  workEmail: 'Work email',
  memberEmailHint: 'Once added, this email can request a secure one-time sign-in link.',
  accessRole: 'Access role',
  memberLastAdminTitle: 'The final administrator cannot be demoted or deactivated.',
  memberLastAdminBody: 'Add another workspace administrator first.',
  memberSelfGuard: 'The current administrator cannot change their own access.',
  deactivateMember: 'Deactivate access',
  restoreMember: 'Restore access',
  saveMember: 'Save changes',
  savingMember: 'Saving…',
  cancel: 'Cancel',
  memberAdded: 'Member added.',
  memberSaved: 'Member permissions updated.',
  memberRevoked: 'Member access deactivated.',
  memberRestored: 'Member access restored.',
  memberExists: 'This email is already in the workspace.',
  memberSaveFailed: 'The member change could not be saved.',
  projectSettingsIntro: 'Manage preferences that apply only to the current project.',
  defaultOutputLanguage: 'Default work and report language',
  defaultOutputLanguageHint: 'Sent as the concrete output_language value for diagnosis reports, strategy and other project AI calls. It does not change the interface language.',
  targetContentLanguages: 'Target content languages',
  targetContentLanguagesHint: 'Select one or more languages for market-facing production. Individual tasks may override this project default.',
  saveLanguageSettings: 'Save language settings',
  savingLanguageSettings: 'Saving…',
  languageSettingsSaved: 'Saved',
  languageSettingsFailed: 'Could not save. Your previous production setting is unchanged.',
  leadSlaTenantTitle: 'Workspace lead response rules',
  leadSlaTenantHint: 'Set the default lead-response timing used by workspace projects. A project can inherit, override or disable it.',
  leadSlaProjectTitle: 'Project lead response rules',
  leadSlaProjectHint: 'Choose whether this project inherits the workspace rule, uses its own rule, or stops future timing.',
  leadSlaLoading: 'Loading the current response rule…',
  leadSlaEffective: 'Currently effective',
  leadSlaEnabled: 'Enabled',
  leadSlaDisabled: 'Disabled',
  leadSlaEffectiveSource: 'Source: {source} · policy revision {revision}',
  leadSlaSourceTenant: 'workspace rule',
  leadSlaSourceProject: 'project rule',
  leadSlaSourceNone: 'no rule yet',
  leadSlaMode: 'This level',
  leadSlaModes: { policy: 'Use an independent rule', disabled: 'Disable', inherit: 'Inherit workspace rule' },
  leadSlaClockMode: 'Timing method',
  leadSlaClockElapsed: 'Continuous time',
  leadSlaClockBusiness: 'Business hours only',
  leadSlaTimezone: 'Time zone',
  leadSlaFirstResponse: 'First response (minutes)',
  leadSlaFollowup: 'Follow-up (minutes)',
  leadSlaWarning: 'Advance warning (minutes)',
  leadSlaBusinessDays: 'Business days',
  leadSlaWeekdays: { 0: 'Mon', 1: 'Tue', 2: 'Wed', 3: 'Thu', 4: 'Fri', 5: 'Sat', 6: 'Sun' },
  leadSlaBusinessStart: 'Starts',
  leadSlaBusinessEnd: 'Ends',
  leadSlaAdminOnly: 'Only a workspace administrator can change this setting.',
  leadSlaValidation: 'Complete every rule field. The warning must be shorter than both response deadlines.',
  leadSlaSave: 'Save response rule',
  leadSlaSaving: 'Saving…',
  leadSlaSaved: 'Response rule saved',
  leadSlaSaveFailed: 'Could not save. Reload the current rule and try again.',
  leadSlaUnavailable: 'The current response rule could not be loaded.',
  leadSlaNoScope: 'The current workspace or project is not available yet.',
  leadSlaClockBoundary: 'A setting change never rewrites a running clock. The current stage finishes under its launch rule; disabled prevents the next stage, while inherit uses the workspace rule effective when the next stage begins.',
  airlockAppearance: 'Website Airlock appearance',
  airlockAppearanceHint: 'Customize the customer-facing reception module on your website. Changes do not affect Navigator itself.',
  airlockLoading: 'Loading the current website appearance…',
  airlockPreviewEyebrow: 'Website reception',
  airlockPreviewTitle: 'How can we help?',
  airlockPreviewBody: 'Preview the approved colors, corner radius and font before saving.',
  airlockPreviewAction: 'Start a conversation',
  airlockColorScheme: 'Light and dark behavior',
  airlockScheme: { auto: 'Follow visitor device', light: 'Always light', dark: 'Always dark' },
  airlockColors: 'Brand colors',
  airlockColorsHint: 'Leaving a color on “website default” lets Airlock use its safe built-in value.',
  airlockAccent: 'Primary action',
  airlockOnAccent: 'Text on primary action',
  airlockSurface: 'Main surface',
  airlockSurfaceAlt: 'Secondary surface',
  airlockText: 'Main text',
  airlockMuted: 'Supporting text',
  airlockLine: 'Borders and dividers',
  airlockInherit: 'Website default',
  airlockUseDefault: 'Use default',
  airlockCornerRadius: 'Corner radius',
  airlockFont: 'Font',
  airlockFontHost: 'Follow website',
  airlockFontSans: 'Navigator Sans',
  airlockFontSerif: 'Navigator Serif',
  airlockSave: 'Save Airlock appearance',
  airlockSaving: 'Saving…',
  airlockSaved: 'Website appearance saved',
  airlockSaveFailed: 'Could not save. Reload the current setting before trying again.',
  airlockUnavailable: 'Website appearance is not available for this project yet.',
  airlockRetry: 'Try again',
  airlockBoundary: 'Only approved colors, radius, font and light/dark behavior are accepted. Custom CSS, URLs and scripts cannot be entered here.',
  subscription: 'Subscription',
  billingLoading: 'Loading your subscription…',
  billingUnavailable: 'Subscription billing is temporarily unavailable.',
  billingEyebrow: 'Navigator billing · Stripe Sandbox',
  billingTitle: 'Plans & subscription',
  billingIntro: 'Choose the operating capacity for this enterprise space. Navigator capabilities keep evolving; plans define capacity, not a frozen feature list.',
  billingSandbox: 'Test mode · no live charge',
  billingEnterprise: 'Billed enterprise space',
  billingCurrent: 'Current subscription',
  billingStatus: {
    AWAITING_PAYMENT: 'Awaiting payment',
    ACTIVE: 'Active',
    CANCEL_AT_PERIOD_END: 'Ends after this period',
    PAST_DUE: 'Payment overdue',
    EXPIRED: 'Expired',
    REFUNDED: 'Refunded',
  },
  billingPeriodEnd: 'Current period ends {date}',
  billingNoSubscription: 'This enterprise space does not have an active subscription yet.',
  billingInterval: 'Billing interval',
  billingMonthly: 'Monthly',
  billingAnnual: 'Annual',
  billingAnnualPromo: '12 months for the price of 10',
  billingPlan: {
    launch: 'For small teams establishing a continuous growth loop.',
    growth: 'For growing teams running more markets and work cycles.',
    scale: 'For organizations operating at higher volume and complexity.',
    enterprise: 'Contract pricing, deployment boundaries and service terms are agreed separately.',
  },
  billingMonthUnit: 'month',
  billingYearUnit: 'year',
  billingStartCheckout: 'Continue to secure checkout',
  billingRedirecting: 'Opening checkout…',
  billingCustom: 'Custom',
  billingContractOnly: 'Contact us',
  billingAdminOnly: 'Only an enterprise-space administrator can start a subscription.',
  billingExistingGuard: 'This space already has a subscription. Plan changes and cancellation are not enabled in this Sandbox stage.',
  billingCheckoutFailed: 'Checkout could not be opened. Your subscription was not changed.',
  billingBoundary: 'Test environment only. Enterprise identity comes from your authenticated Navigator session; prices come from the locked Sandbox pricebook. The browser cannot change either.',
  billingUsageEyebrow: 'Capacity observation',
  billingUsageTitle: 'Business usage this period',
  billingUsageObserveOnly: 'These are research observations only. Reaching a reference value does not stop service, downgrade the workspace, or trigger a charge.',
  billingUsageCounter: {
    completed_cycle: 'Completed cycles',
    standard_artifact: 'Standard deliverables',
    localization_version: 'Localized versions',
    publication_position: 'New publication positions',
    airlock_conversation: 'Airlock AI conversations',
  },
  billingUsageBreakdown: 'Used {used} · in progress {inFlight} · queued {queued}',
  billingUsageNotConnected: 'Data not connected',
  billingUsageNotConnectedDetail: 'Real usage will appear after a trusted business source is connected.',
  billingUsageBoundary: 'Values after the slash are Sandbox observation anchors, not contractual customer allowances.',
  outputLanguageBoundary: 'Navigator owns language selection. Foundry receives one concrete BCP-47 output_language value per call and does not define a global default.',
  settingsBoundary: 'This panel contains customer-facing app and workspace access settings. Internal operations and system controls remain in the separate control surface.',
  settingsDeferred: 'The setting entry and ownership boundary are ready. Detailed fields will be connected only when their production contracts are approved.',
  signedInAs: 'Signed in as',
  signOut: 'Sign out',
  signingOut: 'Signing out…',
  signOutFailed: 'Could not sign out. Check your connection and try again.',
  surfacePendingEyebrow: 'Global shell · Surface wiring',
  surfacePendingTitle: '{route} is being connected',
  surfacePendingBody: 'Navigation, language and settings boundaries are ready. This surface will receive its production content in the corresponding page batch.',
} as const

export default shell
